import React from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography,
  List, ListItem, ListItemText, Link, Box, Divider, Alert,
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

/**
 * Діалог «використовується в …» з кнопкою OK (видалення не виконується).
 * usage: { detail, products: [{id,name,article,role,url}], kits: [...] }
 */
export default function NomenclatureUsageDialog({ open, onClose, usage, itemName }) {
  const products = usage?.products || [];
  const kits = usage?.kits || [];
  const title = itemName
    ? `Не можна видалити «${itemName}»`
    : 'Не можна видалити позицію';

  return (
    <Dialog open={!!open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent dividers>
        <Alert severity="warning" sx={{ mb: 2, whiteSpace: 'pre-line', alignItems: 'flex-start' }}>
          {usage?.detail
            || 'Ця позиція використовується у виробах або комплектах. Спочатку відредагуйте їх, потім повторіть видалення.'}
        </Alert>

        {products.length > 0 && (
          <Box sx={{ mb: 1.5 }}>
            <Typography variant="subtitle2" gutterBottom>Вироби (відкрити для редагування)</Typography>
            <List dense disablePadding>
              {products.map((p) => (
                <ListItem key={`p-${p.id}-${p.role}`} disableGutters sx={{ alignItems: 'flex-start' }}>
                  <ListItemText
                    primary={
                      <Link component={RouterLink} to={p.url || `/products?edit=${p.id}`} onClick={onClose}>
                        {p.name}{p.article ? ` (${p.article})` : ''}
                      </Link>
                    }
                    secondary={p.role}
                  />
                </ListItem>
              ))}
            </List>
          </Box>
        )}

        {kits.length > 0 && (
          <Box>
            {products.length > 0 && <Divider sx={{ mb: 1.5 }} />}
            <Typography variant="subtitle2" gutterBottom>Комплекти (відкрити для редагування)</Typography>
            <List dense disablePadding>
              {kits.map((k) => (
                <ListItem key={`k-${k.id}-${k.role}`} disableGutters>
                  <ListItemText
                    primary={
                      <Link component={RouterLink} to={k.url || `/product-kits?edit=${k.id}`} onClick={onClose}>
                        {k.name}
                      </Link>
                    }
                    secondary={k.role}
                  />
                </ListItem>
              ))}
            </List>
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={onClose} autoFocus>OK</Button>
      </DialogActions>
    </Dialog>
  );
}

/**
 * Перед видаленням: якщо in_use — показати діалог (повертає { blocked: true, usage }).
 * Якщо вільно — звичайний confirm (повертає { blocked: false, confirmed: bool }).
 */
export async function checkNomenclatureDelete(service, id, {
  itemName = '',
  confirmMessage = 'Ви впевнені, що хочете видалити цю позицію?',
} = {}) {
  const res = await service.usage(id);
  const usage = res.data || {};
  if (usage.in_use) {
    return { blocked: true, usage, itemName: itemName || usage.name || '' };
  }
  const confirmed = window.confirm(confirmMessage);
  return { blocked: false, confirmed, usage };
}
